// Design width of marketing/offer emails (px). Emails are never rendered wider than this — it is
// both the shrink-to-fit/measuring cap and the maximum thread card width.
export const MAX_EMAIL_WIDTH = 600;
